import { Component, forwardRef, Output, EventEmitter } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { ProcessTemplateLookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

@Component({
  selector: 'app-process-template-picker',
  standalone: true,
  imports: [
    FormsModule,
    AutoCompleteModule,
  ],
  templateUrl: './base-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProcessTemplatePickerComponent),
      multi: true
    }
  ]
})
export class ProcessTemplatePickerComponent extends BasePickerComponent<ProcessTemplateLookupItem> {
  @Output() sponsorTypeChange = new EventEmitter<number>();

  constructor(private readonly lookupService: LookupService) {
    super();
  }

  // Override handleChange to emit sponsorType when selection changes
  override handleChange(event: any) {
    // Call parent method which now includes the fix for auto-selection issues
    super.handleChange(event);
    
    // Emit sponsorType when selection changes
    if (this.selected && !Array.isArray(this.selected)) {   
      this.sponsorTypeChange.emit(this.selected.sponsorType);
    }
  }

  override search(query: string): Observable<ListResult<ProcessTemplateLookupItem>> {
    return this.lookupService.getProcessTemplates(undefined, query, 20);
  }

  override load(keys: string[]): Observable<ListResult<ProcessTemplateLookupItem>> {
    return this.lookupService.getProcessTemplates(keys);
  }
}
